<template>
  <div class="pageFlexBetweenStart pageMiddleMarginBottom tips">
    <div class="pageHalfRadius" :style="message==''||message==undefined||message==null?'opacity:0;':''" >
      <i class="iconfont icongantanhao"></i>
      <p>{{message}}</p>
    </div>
    <p class="pageFontWeight right">{{title}}</p>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    message: {
      type: String,
      default: "",
    },
    halfRadius: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.tips {
  // margin-top: 16px;
  position: relative;
  .pageHalfRadius {
    position: relative;
    z-index: 2;
    display: flex;
    padding: 6px 8px;
    font-size: 12px;
    background: rgba(0, 0, 0, 0.1);
    .iconfont,
    p {
      color: #fff;
    }
    .iconfont {
      font-size: 20px;
      margin-right: 5px;
      float: left;
      display: flex;
      align-items: center;
    }
  }
  .right {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 35px;
    color: rgba(255, 255, 255, 0.2);
    line-height: 1.2;
  }
  @media screen and (max-width: 360px) {
    .right {
      font-size: 36px;
    }
  }
  @media screen and (max-width: 340px) {
    .right {
      font-size: 28px;
    }
  }
}
</style>
